/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { SCORING_MODEL_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import {
  filterScoring,
  deleteScoring,
  statusChange,
  resetScoringMsg,
  resetCreateScoringStatus
} from 'src/redux/slices/scoring';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

export default function ScoringList({
  setEditId,
  deleteId,
  setDeleteId,
  scoringList,
  scoringListStatus,
  setScoringListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createScoringStatus, scoringMsg } = useSelector((state) => state.scoring);

  useEffect(() => {
    if (createScoringStatus) {
      enqueueSnackbar('Scoring Model Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateScoringStatus());
    }
    if (scoringMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetScoringMsg());
      setTiltle('Disable Scoring Model');
      setContent(scoringMsg);
    }
  }, [scoringMsg, createScoringStatus]);

  const handleScoringListSwitch = (e) => {
    setScoringListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete Scoring Model?');
    setContent('Are you sure want to delete Scoring Model permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteScoring(deleteId));
    enqueueSnackbar('Scoring Model Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('Scoring Model Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={SCORING_MODEL_LIST_HEAD}
          tableData={scoringList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={scoringListStatus}
          switchButton
          filterComponent={filterScoring}
          switchButtonResponse={handleScoringListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
